// Generated by Melange

import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function Partners(Props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h2", {
        children: "Создавайте и развивайте свой бизнес с Бухтой и нашими партнерами.",
        className: "h4 lg:h2 text-black-landing"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "-ml-4",
                alt: "yandex",
                src: StaticAsset.src("/static/icons/yandex-circle.svg")
              }),
              JsxRuntime.jsx("h6", {
                children: "Яндекс",
                className: "h6 text-black-landing"
              }),
              JsxRuntime.jsx("p", {
                children: "Интеграция фискализации (кассовых аппаратов), организация работы таксопарков.",
                className: "paragraph-small lg:paragraph text-gray-landing mt-1"
              })
            ],
            className: "w-39 sm:w-48 lg:w-64"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "-ml-4",
                alt: "jusan",
                src: StaticAsset.src("/static/icons/jusan-circle.svg")
              }),
              JsxRuntime.jsx("h6", {
                children: "Jusan Bank",
                className: "h6 text-black-landing"
              }),
              JsxRuntime.jsx("p", {
                children: "Онлайн-бухгалтерия: сдача налоговых отчетностей, оплата налогов и подготовка первичной документации",
                className: "paragraph-small lg:paragraph text-gray-landing mt-1"
              })
            ],
            className: "w-39 sm:w-48 lg:w-64"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "w-29 -mt-3 -ml-4.5",
                alt: "yandex taxi",
                src: StaticAsset.src("/static/images/yandex-taxi.png")
              }),
              JsxRuntime.jsx("h6", {
                children: "Яндекс.Такси",
                className: "h6 text-black-landing"
              }),
              JsxRuntime.jsx("p", {
                children: "Автоматизация работы касс, организация работы таксопарков и агрегаторов, интеграция с банком.",
                className: "paragraph-small lg:paragraph text-gray-landing mt-1"
              })
            ],
            className: "w-39 sm:w-48 lg:w-64 mt-6 lg:mt-10"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "w-28 -mt-2 -ml-4",
                alt: "yandex food",
                src: StaticAsset.src("/static/images/yandex-food.png")
              }),
              JsxRuntime.jsx("h6", {
                children: "Яндекс.Еда",
                className: "h6 text-black-landing"
              }),
              JsxRuntime.jsx("p", {
                children: "Работа по расчетам с курьерами, и интеграция с банком, выстраивание работы по учету.",
                className: "paragraph-small lg:paragraph text-gray-landing mt-1"
              })
            ],
            className: "w-39 sm:w-48 lg:w-64 mt-6 lg:mt-10"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "w-28 -mt-2 -ml-4",
                src: StaticAsset.src("/static/icons/glovo-circled.svg")
              }),
              JsxRuntime.jsx("h6", {
                children: "Glovo",
                className: "h6 text-black-landing"
              }),
              JsxRuntime.jsx("p", {
                children: "Работа с курьерами ИП, внедрение расчетов, автоматизация выплат, фискализация.",
                className: "paragraph-small lg:paragraph text-gray-landing mt-1"
              })
            ],
            className: "w-39 sm:w-48 lg:w-64 mt-6 sm:mt-0 lg:mt-10"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "w-28 -mt-2 -ml-4",
                src: StaticAsset.src("/static/icons/indrive.svg")
              }),
              JsxRuntime.jsx("h6", {
                children: "inDrive",
                className: "h6 text-black-landing"
              }),
              JsxRuntime.jsx("p", {
                children: "Интеграция фискализации (кассовых аппаратов), организация работы таксопарков.",
                className: "paragraph-small lg:paragraph text-gray-landing mt-1"
              })
            ],
            className: "w-39 sm:w-48 lg:w-64 mt-6 lg:mt-10"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "w-28 -mt-2 -ml-4",
                src: StaticAsset.src("/static/icons/halyk-circled.svg")
              }),
              JsxRuntime.jsx("h6", {
                children: "Халык Банк",
                className: "paragraph text-black-landing"
              }),
              JsxRuntime.jsx("p", {
                children: "Подключи прием платежей через QR код в своем магазине и веди учет в Бухте.",
                className: "paragraph-small lg:paragraph text-gray-landing mt-1"
              })
            ],
            className: "w-39 sm:w-48 lg:w-64 mt-6 lg:mt-10"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "w-28 -mt-2 -ml-4",
                alt: "kyrgyz",
                src: StaticAsset.src("/static/images/kyrgyz.png")
              }),
              JsxRuntime.jsx("h6", {
                children: "Кыргызский коммерческий банк Кыргызстан",
                className: "paragraph text-black-landing"
              }),
              JsxRuntime.jsx("p", {
                children: "Банковская выписка и платежи напрямую из Бухгалтерии теперь и в Кыргызстане!",
                className: "paragraph-small lg:paragraph text-gray-landing mt-1"
              })
            ],
            className: "w-39 sm:w-48 lg:w-64 mt-6 lg:mt-10"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "w-28 -mt-2 -ml-4",
                alt: "kgd",
                src: StaticAsset.src("/static/images/kgd.png")
              }),
              JsxRuntime.jsx("h6", {
                children: "КГД",
                className: "paragraph text-black-landing"
              }),
              JsxRuntime.jsx("p", {
                children: "Работа над внедрением новых форматов взаимодействия налогоплательщика и фискального органа.",
                className: "paragraph-small lg:paragraph text-gray-landing mt-1"
              })
            ],
            className: "w-39 sm:w-48 lg:w-64 mt-6 lg:mt-10"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "w-28 -mt-2 -ml-4",
                alt: "gns",
                src: StaticAsset.src("/static/images/gns.png")
              }),
              JsxRuntime.jsx("h6", {
                children: "ГНС",
                className: "paragraph text-black-landing"
              }),
              JsxRuntime.jsx("p", {
                children: "Внедрение новых технологических решений для упрощения жизни налогоплательщиков.",
                className: "paragraph-small lg:paragraph text-gray-landing mt-1"
              })
            ],
            className: "w-39 sm:w-48 lg:w-64 mt-6 lg:mt-10"
          })
        ],
        className: "flex justify-between mt-6 lg:mt-10 flex-wrap"
      }),
      JsxRuntime.jsx("hr", {
        className: "text-divider mt-6 lg:mt-10"
      }),
      JsxRuntime.jsxs("p", {
        children: [
          "По вопросам сотрудничества и партнерства пишите на ",
          JsxRuntime.jsx("a", {
            children: "hello@buhta.com",
            className: "text-primary underline",
            href: "mailto:hello@buhta.com"
          })
        ],
        className: "paragraph-small lg:paragraph text-black-landing mt-6 lg:mt-10"
      })
    ],
    className: "pt-10 lg:pt-0 px-6 sm:px-48 lg:px-0"
  });
}

const make = Partners;

export {
  make,
}
/* react/jsx-runtime Not a pure module */
